// src/RPGManager.js

export class RPGManager {
  constructor(uiElements, economy, perkTree, callbacks) {
    this.ui = uiElements;
    this.economy = economy;
    this.perkTree = perkTree;
    this.callbacks = callbacks; // { playClick, saveEconomyState, refreshUI, notify }
  }

  renderQuests() {
    if (!this.ui.questList) return;
    this.ui.questList.innerHTML = '';

    // Only generate if no quests exist yet for today (prevents resetting progress on every refreshUI)
    this.economy.rpg.generateDailyQuests();

    this.economy.rpg.dailyQuests.forEach(q => {
      const el = document.createElement('div');
      el.className = `quest-item ${q.completed ? 'completed' : 'pending'}`;

      const targetCount = q.target.count || q.target.streak || q.target.library_cases || 1;
      const progressPercent = Math.min(100, (q.progress / targetCount) * 100);
      const progressLabel = `${q.progress}/${targetCount}`;

      el.innerHTML = `
        <div class="quest-header">
          <strong>${q.title}</strong>
          <span>${q.completed ? '✅' : progressLabel}</span>
        </div>
        <div class="quest-desc">${q.desc}</div>
        <div class="quest-progress-bg">
           <div class="quest-progress-bar ${q.completed ? 'completed' : 'pending'}" style="width:${progressPercent}%;"></div>
        </div>
      `;
      this.ui.questList.appendChild(el);
    });
  }

  renderPerkTree() {
    if (!this.ui.perkTreeContainer) return;
    this.ui.perkTreeContainer.innerHTML = '';
    this.ui.perkTreeContainer.style.display = 'flex';
    this.ui.perkTreeContainer.style.flexDirection = 'column';
    this.ui.perkTreeContainer.style.gap = '25px';

    const playerLevel = this.economy.state.playerLevel;
    
    // Group nodes by branch
    const branches = {};
    this.perkTree.nodes.forEach(node => {
      const b = node.branch || 'universal';
      if (!branches[b]) branches[b] = [];
      branches[b].push(node);
    });

    const branchTitles = {
      'diagnostico': '🩺 Rama de Diagnóstico (Velocidad & Pistas)',
      'manejo': '💊 Rama de Manejo (Estabilidad & Recuperación)',
      'guardia': '☕ Rama de Guardia (Recuperación & Sostenibilidad)',
      'universal': '🌟 Habilidades Universales'
    };

    Object.entries(branches).forEach(([branchKey, nodes]) => {
      const section = document.createElement('div');
      section.className = 'perk-branch-section';
      
      const title = document.createElement('h3');
      title.className = 'perk-branch-title';
      title.textContent = branchTitles[branchKey] || branchKey.toUpperCase();
      section.appendChild(title);

      const grid = document.createElement('div');
      grid.className = 'perk-grid';
      
      nodes.forEach(node => {
        const isUnlocked = this.economy.rpg.activePerks.includes(node.id);
        const canUnlock = this.economy.rpg.canUnlockPerk(node.id, playerLevel);

        const card = document.createElement('div');
        let statusClass = 'locked-cannot-unlock';
        if (isUnlocked) {
            statusClass = 'unlocked';
        } else if (canUnlock) {
            statusClass = 'locked-can-unlock';
        }
        card.className = `card perk-card ${statusClass}`;

        card.innerHTML = `
            <div>
              <div class="perk-tier">Tier ${node.tier}</div>
              <strong class="perk-name">${node.name}</strong>
              <p class="perk-desc">${node.desc}</p>
            </div>
            <div class="perk-footer">
                <span class="perk-cost">Costo: ${node.cost_sp} SP</span>
                <button class="unlock-btn glass-btn btn-sm perk-unlock-btn ${isUnlocked ? 'unlocked' : 'can-unlock'}" data-id="${node.id}" 
                    ${isUnlocked ? 'disabled' : (canUnlock ? '' : 'disabled')}>
                    ${isUnlocked ? '✓ Aprendido' : 'Aprender'}
                </button>
            </div>
        `;

        const btn = card.querySelector('.unlock-btn');
        if (btn && !isUnlocked && canUnlock) {
          btn.onclick = () => {
            if (this.economy.rpg.unlockPerk(node.id, playerLevel)) {
              if (this.callbacks.playClick) this.callbacks.playClick();
              if (this.callbacks.saveEconomyState) this.callbacks.saveEconomyState(this.economy.exportState());
              this.renderPerkTree();
              if (this.callbacks.refreshUI) this.callbacks.refreshUI();
              if (this.callbacks.notify) this.callbacks.notify(`¡Talento "${node.name}" aprendido!`);
            }
          };
        }

        grid.appendChild(card);
      });

      section.appendChild(grid);
      this.ui.perkTreeContainer.appendChild(section);
    });

    if (this.ui.modalSpCount) {
      this.ui.modalSpCount.innerText = this.economy.rpg.skillPoints;
    }
  }
}
